<script setup>
  import { ref } from 'vue';
  import InputText from 'primevue/inputtext';
  import Button from 'primevue/button';
import { authAPI } from '../service/api.js';
import { useToast } from "primevue/usetoast";
import { useAuth } from '../composables/useAuth';

const toast = useToast();
const { login } = useAuth();

  const username = ref('');
  const password = ref('');

  const handleLogin = async () => {
    try {
      const response = await authAPI.login(
        {
          username: username.value,
          password: password.value
        }
      );

      if (response.status === 401) {
        toast.add({ severity: 'error', summary: 'Login Failed', detail: 'Invalid username or password', life: 3000 });
        return;
      }

      if (response.status !== 200) {
        console.log('Login failed:', response);
        toast.add({ severity: 'error', summary: 'Login Failed', detail: 'Invalid username or password', life: 3000 });
        return;
      }
      const data = response.data;
      // Pass the full payload — useAuth seeds useCurrentUser when username +
      // roles are present, so role-gated UI renders immediately without
      // waiting for a separate /me round-trip.
      if (data.token) {
        login(data);
      }
    } catch (error) {


      // Handle login error (display message to user)
      toast.add({ severity: 'error', summary: 'Login Failed', detail: 'An error occurred during login', life: 3000 });
      console.error('Login error:', error);
    }
  };

</script>

<template>
  <div class="login-page">
    <div class="login-container">
      <h2 class="login-title">Login</h2>
      <form class="login-form">
        <div class="form-group">
          <label for="username">Username</label>
          <InputText id="username" v-model="username" placeholder="Enter your username" />
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <InputText id="password" v-model="password" placeholder="Enter your password" type="password" />
        </div>
        <div class="form-actions">
          <Button label="Login" @click="handleLogin" class="login-button" />
        </div>
      </form>
    </div>
  </div>
</template>

<style>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.login-container {
  width: 100%;
  max-width: 400px;
  padding: 2rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.login-title {
  margin-bottom: 1.5rem;
  text-align: center;
  color: #333;
  font-size: 1.75rem;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 500;
  color: #555;
}

.form-actions {
  margin-top: 1rem;
}

.login-button {
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
}

.form-footer {
  margin-top: 1rem;
  text-align: center;
}

.forgot-password {
  color: #4c85f2;
  text-decoration: none;
  font-size: 0.875rem;
}

.forgot-password:hover {
  text-decoration: underline;
}
</style>
